import {AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, QueryList, ViewChildren} from '@angular/core';
import {Formation, Piece, PieceService} from '../../formation';
import {ConfirmationService} from 'primeng/components/common/api';
import {TranslateService} from 'ng2-translate';
import {AlertService} from 'ng-jhipster';
import {Observable} from 'rxjs';
import {Editor} from 'primeng/primeng';
import {Principal} from "../../../shared";

@Component({
    selector: 'jhi-piece-component',
    templateUrl: 'piece.component.html'
})
export class PieceComponent implements OnChanges, AfterViewInit {

    @Input() pieces: Piece[];
    @Output() piecesChange: EventEmitter<Piece[]> = new EventEmitter();
    @Input() formation: Formation;
    @Input() categorieFormationId: Number;
    @Input() currentLang: string;
    @Input() disabled: boolean;
    @Input() isResponsableFormation: boolean;
    @Input() isAdminOrGestionnaireOrSystem: boolean;
    @Input() isOnlyEnseignant: boolean;
    @Input() isEnseignantOrResponsableFormation: boolean;
    @Input()uniquementMajPlacesFormation: boolean;
    @ViewChildren(Editor) editorList: QueryList<Editor>;

    aide: Boolean[] = [];
    descriptif: Boolean[] = [];
    exportRentree: Boolean[] = [];

    constructor(
        private confirmationService: ConfirmationService,
        private pieceService: PieceService,
        private alertService: AlertService,
        private translateService: TranslateService,
        private principal: Principal) {
        this.translateService.onLangChange.subscribe(lang => this.currentLang = lang.lang);
    }

    ngAfterViewInit() {
        // les <p-dialog [disabled]=true> ne fonctionnent pas, contournement ci-après
        if (this.disabled) {
            this.editorList.forEach(
                editor => {
                    editor.quill.disable();
                });
        }
    }


    ngOnChanges() {
        if (this.pieces && this.pieces.length) {
            this.pieces.forEach((piece, idx) => this.aide[idx] = piece.aide != null);
            this.pieces.forEach((piece, idx) => this.descriptif[idx] = piece.descriptif != null);
        }
    }

    onChangePieceObligatoire(piece: Piece, idx: number) {
        const texteObligatoire = this.translateService.instant('cadensApp.formation.piece.televersementObligatoire');
        const texteObligatoireP = "<p>"+this.translateService.instant('cadensApp.formation.piece.televersementObligatoire')+"</p>";
        const chainePBr="<p><br></p>"

        // Supprimer toutes les occurrences de <p><br></p> dans descriptif/descriptifEn
        if (this.currentLang === 'fr' && piece.descriptif) {
            piece.descriptif = piece.descriptif.replace(new RegExp(chainePBr, 'g'), '').trim();
        } else if (this.currentLang !== 'fr' && piece.descriptifEn) {
            piece.descriptifEn = piece.descriptifEn.replace(new RegExp(chainePBr, 'g'), '').trim();
        }
        if (piece.obligatoire) {
            console.log("langue :",this.currentLang);
            // Ajoute le texte "téléversement obligatoire" si ce n'est pas déjà présent
            if (this.currentLang === 'fr') {
                if (!piece.descriptif || !piece.descriptif.includes(texteObligatoire) || !piece.descriptif.includes(texteObligatoireP)) {
                    piece.descriptif = piece.descriptif ?  texteObligatoireP+ '\n' + piece.descriptif  : texteObligatoireP;
                }
            } else {
                if (!piece.descriptifEn || !piece.descriptifEn.includes(texteObligatoire) || !piece.descriptifEn.includes(texteObligatoireP)) {
                    piece.descriptifEn = piece.descriptifEn ? texteObligatoireP+ '\n' + piece.descriptifEn  : texteObligatoireP;
                }
            }
        } else {
            // Supprime le texte "téléversement obligatoire" en anglais s'il est présent
            if (this.currentLang === 'fr' && piece.descriptif) {
                piece.descriptif = piece.descriptif.replace(new RegExp('\n?' + texteObligatoireP, 'g'), '').trim();
                piece.descriptif = piece.descriptif.replace(new RegExp('\n?' + texteObligatoire, 'g'), '').trim();
            } else if (this.currentLang !== 'fr' && piece.descriptifEn) {
                piece.descriptifEn = piece.descriptifEn.replace(new RegExp('\n?' + texteObligatoireP, 'g'), '').trim();
                piece.descriptifEn = piece.descriptifEn.replace(new RegExp('\n?' + texteObligatoire, 'g'), '').trim();
            }
        }
    }

    addPiece() {
        if (!this.pieces) {
            this.pieces = [];
        }
        this.pieces.push(this.newPiece());
        this.piecesChange.emit(this.pieces);
    }

    clearPiece(index, pieceId) {
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.pieceJointe.delete.question'),
            header: this.translateService.instant('cadensApp.pieceJointe.delete.title'),
            key: 'deletePiece',
            accept: () => {
                if (pieceId != null) {
                    let piece = this.pieces[index];
                    let updates = [];
                    if (piece.commonIds != null && piece.commonIds.length > 0) {
                        piece.commonIds.forEach(p => {
                            updates.push(this.pieceService.delete(p));
                        });
                    } else {
                        updates.push(this.pieceService.delete(pieceId));
                    }
                    Observable.forkJoin(updates).subscribe(result => {
                        this.pieces.splice(index, 1);
                        this.piecesChange.emit(this.pieces);
                    }, error => {
                        this.alertService.error(error.message, null, null);
                    });
                } else {
                    this.pieces.splice(index, 1);
                    this.piecesChange.emit(this.pieces);
                }
            },
            reject: () => {
            }
        });
    }

    private newPiece() {
        let piece: Piece = { obligatoire: false };
        if (this.formation) {
            piece.formationId = this.formation.id;
        }
        if (this.categorieFormationId != null) {
            piece.categorieFormationId = this.categorieFormationId.valueOf();
        }

        return piece;
    }

    isPasDeModification() {
        if (this.disabled) {
            return this.disabled;
        }
        return null;

    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/blocks/piece/piece.component.ts